/**
 * @tttrpg/content — icerik indeksi
 *
 * Icerik bir "indeks" olarak sunulur: motor `content.classes[id]` ile erisir.
 * Bu sayede yeni bir sinif/irk/eşya eklemek icin motoru degistirmek gerekmez —
 * sadece buraya bir kayit eklenir. (Homebrew desteğinin temeli budur.)
 */

import type { ContentIndex, RaceEntry } from '@tttrpg/rules'
import { AGAC_INSANI } from './homebrew/agac-insani'
import { EJDER_SOYLU } from './homebrew/ejder-soylu'
import {
  BALIK_ADAMLARI,
  BITKI_HALKI,
  BULUT_HALKI,
  CRA,
  ELIATROP,
  GOLGE_HALKI,
  INSAN,
  IOP,
  KRISTAL_HALKI,
  MANTAR_HALKI,
  SEKER_HALKI,
  ZAMAN_KAYMASI,
} from './homebrew/index'
import { BUYUDOGMUS, CATLAKDOGAN, HAYVAN_HALKI, MUTANT, VAMPIR } from './homebrew/rates-pending'
import { HIGH_ELF, ITEMS, PALADIN, SOLDIER, SPELLS } from './srd'

function toRecord<T extends { id: string }>(items: T[]): Record<string, T> {
  const out: Record<string, T> = {}
  for (const item of items) out[item.id] = item
  return out
}

/**
 * ROBOT — KURAL METNİ BEKLENİYOR
 *
 * DM'den metin henüz gelmedi. Uydurma yerine kayıt BOŞ bırakıldı:
 * arayüzde görünür (böylece eksiklik gözden kaçmaz), oynanamaz.
 * `content-completeness.test.ts` bu durumu izliyor; metin gelince
 * `features` doldurulur.
 */
const ROBOT: RaceEntry = {
  id: 'robot',
  name: 'Robot (metin bekleniyor)',
  size: 'Orta',
  reach: 5,
  speed: 30,
  abilityBonuses: {},
  asiChoices: {},
  asi: 0,
  asiChoiceOptions: [],
  acBase: 10,
  darkvision: 0,
  cantrips: [],
  feat: null,
  choices: [],
  innateSpells: [],
  features: [],
}

export const RACES: RaceEntry[] = [
  // --- SRD ---
  HIGH_ELF,
  // --- Özel ırklar: tam tanımlı ---
  EJDER_SOYLU,
  AGAC_INSANI,
  ELIATROP,
  SEKER_HALKI,
  BALIK_ADAMLARI,
  MANTAR_HALKI,
  BULUT_HALKI,
  GOLGE_HALKI,
  BITKI_HALKI,
  ZAMAN_KAYMASI,
  KRISTAL_HALKI,
  IOP,
  CRA,
  INSAN,
  // --- Özel ırklar: seçim listeleri bekleniyor ---
  MUTANT,
  HAYVAN_HALKI,
  BUYUDOGMUS,
  CATLAKDOGAN,
  VAMPIR,
  // --- Metin bekleniyor ---
  ROBOT,
]

import { PATHS } from './paths'

export const CONTENT: ContentIndex = {
  classes: toRecord([PALADIN]),
  races: toRecord(RACES),
  backgrounds: toRecord([SOLDIER]),
  items: toRecord(ITEMS),
  spells: toRecord(SPELLS),
  features: {},
  paths: toRecord(PATHS),
}

export * from './homebrew/agac-insani'
export * from './homebrew/ejder-soylu'
export * from './homebrew/index'
export * from './homebrew/rates-pending'
export * from './kaelen'
export * from './srd'
export type { ContentIndex }
